import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { KeeniconComponent } from '../keenicon/keenicon.component';

@Component({
  selector: 'ui-title',
  imports: [KeeniconComponent],
  templateUrl: './title.component.html',
  styleUrl: './title.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitleComponent {
  icon = input('');
  text = input('');
  iconClass = input('fs-2 text-primary');
  separator = input(true);
}
